<template>
  <div class="float-right">
    <b-modal
        ref="create-import-modal"
        :title="$t('modal.title.import_dictionary_file')"
        size="lg">
      <div class="create-question">
        <div class="row">
          <div class="col-12">
            <b-form-group :label="$t('form.label.attach_file')" label-cols-sm="5">
              <b-form-file
                  v-model="file"
                  :placeholder="$t('import.file.choose_label')"
                  :drop-placeholder="$t('import.file.drop_placeholder')"
                  :browse-text="$t('import.file.browse_text')"
                  accept=".csv"
                  id="file"
                  ref="file"
                  :disabled="responseOrErrorMessage"></b-form-file>
              <p v-if="$v.file.$dirty && !$v.file.required" class="text-danger">{{ $t('error.required') }}</p>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <b-form-group v-if="responseOrErrorMessage" :label="$t('import.label.import_log')">
              <b-form-textarea
                  id="textarea"
                  readonly
                  v-model="responseOrErrorMessage"
                  rows="3"
                  max-rows="6"
                  :class="[ importSuccessful ? 'text-success' : 'text-danger' ]"
              >
              </b-form-textarea>
            </b-form-group>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <div class="buttons float-right">
            <b-button type="button" variant="secondary" class="mr-2"  @click="hideModal">{{$t('btn.close')}}</b-button>
            <b-button :disabled="busy" v-if="!responseOrErrorMessage" type="submit" variant="primary" @click="handleCreateOk">
              <div v-if="busy">
                <b-spinner small type="grow"></b-spinner>
                {{ $t('btn.state.importing') }}
              </div>
              <div v-else>
                {{ $t('btn.import') }}
              </div>
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import {required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";

//TODO: import / load / get locale the right way
let locale = locale ? locale : "en";

export default {
  mixins: [validationMixin],
  data() {
    return {
      apiKey: null,
      file: null,
      responseOrErrorMessage: null,
      importSuccessful: null,
      busy: false
    };
  },
  validations: {
    file: {
      required
    }
  },
  methods: {
    validateState(entry) {
      entry = this.$v.data[entry];

      const {$dirty, $error} = entry;
      return $dirty ? !$error : null;
    },
    openModal() {
      this.$emit('open-create-import-modal');
      this.resetForm();

      this.$refs['create-import-modal'].show()
    },
    handleCreateOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.handleCreateSubmit()
    },
    handleFileUpload(categoryId) {
      this.data.file = this.$refs.file.files[0];
      this.submitFile(categoryId);
    },
    handleCreateSubmit() {
      const dictionaryName = this.$route.params.entry;

      this.$v.$touch();
      let isValid = this.$v.$invalid === false;

      if (isValid) {
        this.busy = true;
        let formData = new FormData();

        formData.append('entries', this.file);

        axios.post( `/api/dictionary/${dictionaryName}/import `,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
        ).then(response => {
          this.busy = false;
          this.importSuccessful = true;
          this.createdResponseMessage(response);

          setTimeout(() => {
            this.$parent.$emit('refreshGrid');
          }, 1000);
        }).catch(error => {
          this.busy = false;
          this.importSuccessful = false;
          this.createdResponseMessage(error);
        });
      }
    },
    createdResponseMessage(responseOrError) {
      const isErrorType = responseOrError.response;
      const status = isErrorType ?  responseOrError.response.data.label : responseOrError.data.status;
      const dataFromResponseOrError = isErrorType ? responseOrError.response.data.parameters : responseOrError.data.log;
      const groupedMessagesByLabelName = Array.from(dataFromResponseOrError.reduce((m, o) => m.set(o[1], (m.get(o[1]) || []).concat([o])), new Map).values());
      const messages = [];

      groupedMessagesByLabelName.forEach((item) => {
        let singleMessage = [];

        item.forEach((message, index) => {
          if(typeof message === 'string') {
            messages.push(message);
          }

          if(typeof message === 'object') {
            if(index === 0) {
              singleMessage.push(message[1]);
              singleMessage.push(message[0]);
            } else {
              singleMessage.push(message[0]);
            }
          }
        });

        if(singleMessage.length) {
          messages.push(singleMessage);
          singleMessage = [];
        }
      });

      const translatedLabels = messages.map(item => {
        if(typeof item === 'string') {
          return this.$t(item);
        }

        if(typeof item === 'object') {
          let message = `${this.$t(item[0])}: `;

          item.forEach((value, index) => {
            if(index > 0) {
              message = `${message} ${value} `;
            }
          });

          return message;
        }
      });

      if(status) {
        translatedLabels.unshift(status);
      }

      this.responseOrErrorMessage = translatedLabels.join('\n');
    },
    resetForm() {
      this.$v.$reset();
    },
    hideModal() {
      this.$refs['create-import-modal'].hide();
    }
  }
}
</script>
